var contactUsSelector = $('#contact-us');
var close_contact = document.getElementById("contact-us-close");
var lightOverlay = document.getElementById("light-overlay");

export default function closeContact(event) {
  event.preventDefault();
  lightOverlay.classList.toggle('is-active--light-overlay');
}